import moment from 'moment';

export function useDateFormat() {
	const dateFormat = (value, format) => {
        if (!value) return '';
        return moment.parseZone(value).format(format ? format : 'D MMMM YYYY, hh:mma');
    };

    return { dateFormat };
}
